"use strict";

var _classCallCheck = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var NODE_TYPE = require("../node-type");

var _require = require("../helpers/node"),
    nodeRoot = _require.nodeRoot;

var _require2 = require("../helpers/shadow-dom"),
    retarget = _require2.retarget;

var DocumentOrShadowRootImpl =
/*#__PURE__*/
function () {
  function DocumentOrShadowRootImpl() {
    _classCallCheck(this, DocumentOrShadowRootImpl);
  }

  _createClass(DocumentOrShadowRootImpl, [{
    key: "activeElement",
    get: function get() {
      var candidate = this._ownerDocument._lastFocusedElement || this._ownerDocument.body;

      if (!candidate) {
        return null;
      }

      candidate = retarget(candidate, this);

      if (nodeRoot(candidate) !== this) {
        return null;
      }

      if (candidate.nodeType !== NODE_TYPE.DOCUMENT_NODE) {
        return candidate;
      }

      if (candidate.body !== null) {
        return candidate.body;
      }

      return candidate.documentElement;
    }
  }]);

  return DocumentOrShadowRootImpl;
}();

module.exports = {
  implementation: DocumentOrShadowRootImpl
};